import PoolBasics from './create_type'
import { connect } from 'react-redux'
import { formatMoney } from 'client/griffin'
import { getCampaignSelector } from 'redux/selectors/campaign'
import { getMaxLimitReachedSelector } from 'redux/selectors/cip'
import { CROWDFUNDING_GOAL_AMOUNT } from 'shared/shared_consts'

const mapStateToProps = (state, props) => {
  const { MAX_AMOUNT } = CROWDFUNDING_GOAL_AMOUNT[state.country.country_code]
  const isBusinessAccount = state.flags.is_business_account
  const campaign = getCampaignSelector(state, props)
  const isGNCEnabled = state.flags.is_gnc_enabled
  const countryCode = state.country.country_code
  const money_pool_creation_blocked =
    state.current_user.money_pool_creation_blocked

  const formattedMaxGoalAmount = formatMoney(campaign.currency, MAX_AMOUNT, {
    removeTrailingZeros: true,
  })

  const isCampaignLimitReached = getMaxLimitReachedSelector(state)

  return {
    countryCode,
    formattedMaxGoalAmount,
    isBusinessAccount,
    isGNCEnabled,
    isCampaignLimitReached,
    money_pool_creation_blocked,
  }
}

export default connect(mapStateToProps)(PoolBasics)
